export enum FieldType {
  cnpj = 'cnpj',
  cpf = 'cpf',
  currency = 'currency',
  date = 'date',
  email = 'email',
  number = 'number',
  tel = 'tel',
  text = 'text',
  zipcode = 'zipcode',
  professionalEmail = 'professionalEmail',
}
